import React from "react";
import Chart from "react-apexcharts";
import "./ConsumptionChart.scss";
import { PiChartLine } from "react-icons/pi";
import type { ApexOptions } from "apexcharts";

const ConsumptionChart: React.FC = () => {
  const series = [
    {
      name: "Immobilien",
      data: [8.0, 6.0, 14.5, 19.0, 21.5, 27.0, 11.0],
    },
    {
      name: "Spielstation",
      data: [7.0, 4.8, 12.0, 16.5, 18.5, 25.0, 10.0],
    },
    {
      name: "FitX",
      data: [2.5, 2.2, 8.5, 10.5, 12.0, 16.5, 4.0],
    },
  ];

  const chartOptions: ApexOptions = {
    chart: {
      height: 350,
      type: "line",
      fontFamily: "inherit",
      foreColor: "#64748b",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    colors: ["#10b981", "#1e1b4b", "#f59e0b"],
    stroke: {
      curve: "smooth",
      width: 3,
    },
    fill: {
      type: "solid",
      opacity: [1, 1, 1],
    },
    markers: {
      size: 0,
      hover: {
        size: 5,
      },
    },
    grid: {
      show: true,
      borderColor: "#f1f5f9",
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    labels: ["00:00", "04:00", "08:00", "12:00", "16:00", "20:00", "23:59"],
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      min: 0,
      max: 28,
      tickAmount: 4,
      labels: {
        formatter: (val) => val.toFixed(1),
      },
    },
    tooltip: {
      y: {
        formatter: (val) => val.toFixed(1) + " MW",
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      offsetY: 8,
    },
  };

  return (
    <div className="consumption-chart">
      <div className="consumption-chart__header">
        <div className="consumption-chart__title-group">
          <div className="consumption-chart__icon-wrapper">
            <PiChartLine className="consumption-chart__icon" />
          </div>
          <h3 className="consumption-chart__title">Lastgang-Analyse (Heute)</h3>
        </div>
        <span className="consumption-chart__unit-badge">MW (Megawatt)</span>
      </div>

      <div className="consumption-chart__container">
        <Chart
          options={chartOptions}
          series={series}
          type="line"
          height={350}
        />
      </div>
    </div>
  );
};

export default ConsumptionChart;
